module.exports = __webpack_public_path__ + "img/symbinet-hero.db3c18f6.png";